
    <body>
    <h2>Add New Listing</h2>
      <div id = "listing-preview">
        <img id="images" src="http://placehold.it/180" alt="listing image" required/> 
        <!-- Book Elements in Preview-->
        <h4><strong>{{this.listingForm.value.listingTitle}}</strong></h4>
        <p *ngIf="listingForm.value.bookElements.bookTitle && listingForm.value.category === 'books'"><strong>Book Title: </strong>{{this.listingForm.value.bookElements.bookTitle}}</p> 
        <p *ngIf="listingForm.value.bookElements.edition && listingForm.value.category === 'books'"><strong>Edition: </strong>{{this.listingForm.value.bookElements.edition}}</p> 
        <p *ngIf="listingForm.value.bookElements.courseNum && listingForm.value.category === 'books'"><strong>Course Number: </strong>{{this.listingForm.value.bookElements.courseNum}}</p> 

        <!-- Clothing Elements in Preview-->
        <p *ngIf="listingForm.value.clothingElements.type && listingForm.value.category === 'clothing'"><strong>Type: </strong>{{this.listingForm.value.clothingElements.type}}</p> 
        <p *ngIf="listingForm.value.clothingElements.color && listingForm.value.category === 'clothing'"><strong>Color: </strong>{{this.listingForm.value.clothingElements.color}}</p> 
        <p *ngIf="listingForm.value.clothingElements.size && listingForm.value.category === 'clothing'"><strong>Size:</strong> {{this.listingForm.value.clothingElements.size}}</p> 

        <!-- Furniture Elements in Preview-->
        <p *ngIf="listingForm.value.furnitureElements.type && listingForm.value.category === 'furniture'"><strong>Type: </strong>{{this.listingForm.value.furnitureElements.type}}</p> 
        <p *ngIf="listingForm.value.furnitureElements.color && listingForm.value.category === 'furniture'"><strong>Color: </strong>{{this.listingForm.value.furnitureElements.color}}</p> 
        <p *ngIf="listingForm.value.furnitureElements.length && listingForm.value.category === 'furniture'"><strong>Length:</strong> {{this.listingForm.value.furnitureElements.length}} in.</p> 
        <p *ngIf="listingForm.value.furnitureElements.width && listingForm.value.category === 'furniture'"><strong>Width: </strong>{{this.listingForm.value.furnitureElements.width}} in.</p> 
        <p *ngIf="listingForm.value.furnitureElements.height && listingForm.value.category === 'furniture'"><strong>Height: </strong>{{this.listingForm.value.furnitureElements.height}} in.</p> 
        <p *ngIf="listingForm.value.furnitureElements.weight && listingForm.value.category === 'furniture'"><strong>Weight: </strong>{{this.listingForm.value.furnitureElements.weight}} lb.</p> 

        <!-- Electronics Elements in Preview-->
        <p *ngIf="listingForm.value.electronicsElements.type && listingForm.value.category === 'electronics'"><strong>Type: </strong>{{this.listingForm.value.electronicsElements.type}}</p> 
        <p *ngIf="listingForm.value.electronicsElements.model && listingForm.value.category === 'electronics'"><strong>Model:</strong> {{this.listingForm.value.electronicsElements.model}}</p> 
        <p *ngIf="listingForm.value.electronicsElements.length && listingForm.value.category === 'electronics'"><strong>Length: </strong>{{this.listingForm.value.electronicsElements.length}} in.</p> 
        <p *ngIf="listingForm.value.electronicsElements.width && listingForm.value.category === 'electronics'"><strong>Width: </strong>{{this.listingForm.value.electronicsElements.width}} in.</p> 
        <p *ngIf="listingForm.value.electronicsElements.height && listingForm.value.category === 'electronics'"><strong>Height: </strong>{{this.listingForm.value.electronicsElements.height}} in.</p> 
        <p *ngIf="listingForm.value.electronicsElements.weight && listingForm.value.category === 'electronics'"><strong>Weight: </strong>{{this.listingForm.value.electronicsElements.weight}} lb.</p> 

        <!-- Sportsgear Elements in Preview-->
        <p *ngIf="listingForm.value.sportsGearElements.type && listingForm.value.category === 'sportsgear'"><strong>Type: </strong>{{this.listingForm.value.sportsGearElements.type}}</p> 
        <p *ngIf="listingForm.value.sportsGearElements.weight && listingForm.value.category === 'sportsgear'"><strong>Weight: </strong>{{this.listingForm.value.sportsGearElements.weight}} lb.</p> 

        <p><strong>Description: </strong>{{this.listingForm.value.description}}</p>
        <p><strong>Price:</strong> ${{this.listingForm.value.price}}</p> 
        
        <p><strong>Item Status: </strong>{{this.listingForm.value.itemStatus}}</p>
        <p><strong>Exchange Location: </strong>{{this.listingForm.value.exchangeLoc}}</p>
        <p><strong>Payment Option:</strong> {{this.listingForm.value.paymentOpt}}</p>
    </div>

    <form [formGroup] = "listingForm">
        <label for="category">Select a Listing Category</label> <br>
            <select id="category" formControlName="category" required>
                <option value="" disabled selected hidden>Item Category</option>
                <option value="books">Book</option>
                <option value="clothing">Clothing</option>
                <option value="furniture">Furniture</option>
                <option value="electronics">Electronics</option>
                <option value="sportsgear">Sportsgear</option>
            </select><br>
            <label> 
            
            <input type="text" id="listingTitle" placeholder="Listing Title" formControlName="listingTitle" required>
            </label>

        <div class="books specific-elements" formGroupName="bookElements" style="display: none;">
            <input type="text" id="bookTitle" placeholder="Book Title" formControlName="bookTitle" required>

            <br>
            <input type="text" placeholder="Edition" formControlName="edition" required/>
            <br>
            <input type="text" placeholder="Course Number" formControlName="courseNum" required>
        </div>
        
 

        <div class="clothing specific-elements" formGroupName="clothingElements" style="display: none;">
            <input type="text" placeholder="Type" formControlName="type" required>
            <br>
            <input type="text" placeholder="Color" formControlName="color" required>
            <br>
            <input type="text" placeholder="Size" formControlName="size" required>
        </div>

    
        <div class="furniture specific-elements" formGroupName="furnitureElements" style="display: none;">
            <input type="text" placeholder="Type" formControlName="type" required>
            <br>
            <input type="text" placeholder="Color" formControlName="color" required>
            <br>
            <label>Dimensions: </label><br>
                <input type="text" placeholder="Length" formControlName="length" pattern="[^[0-9]*$]" required> in.
                <input type="text" placeholder="Width" formControlName="width" pattern="[^[0-9]*$]" required> in.
                <input type="text" placeholder="Height" formControlName="height" pattern="[^[0-9]*$]" required> in.
                <br>
                <p style="color:rgb(105, 0, 0)">Please enter numbers.</p>
                <br>
            <input type="text" placeholder="Weight" formControlName="weight" pattern="[^[0-9]*$]" required> lb.
            <br>
            <p style="color:rgb(105, 0, 0)">Please enter numbers.</p>
        </div>


        <div class="electronics specific-elements" formGroupName="electronicsElements" style="display: none;">
            <input type="text" placeholder="Type" formControlName="type" required>
            <br>
            <input type="text" placeholder="Model" formControlName="model" required>
            <br>
            <label>Dimensions: </label><br>
                <input type="text" placeholder="Length" formControlName="length" pattern="[^[0-9]*$]" required> in.
                <input type="text" placeholder="Width" formControlName="width" pattern="[^[0-9]*$]" required> in. 
                <input type="text" placeholder="Height" formControlName="height" pattern="[^[0-9]*$]" required> in.
                <br>
                <p style="color:rgb(105, 0, 0)">Please enter numbers.</p>
            <br>
            <input type="text" placeholder="Weight" formControlName="weight" pattern="[^[0-9]*$]" required> lb.
            <br>
            <p style="color:rgb(105, 0, 0)">Please enter numbers.</p>
        </div>


        <div class="sportsgear specific-elements" formGroupName="sportsGearElements"  style="display: none;">
            <input type="text" placeholder="Type" formControlName="type" required>
            <br>
            <input type="text" placeholder="Weight" formControlName="weight" pattern="[^[0-9]*$]" required> lb.
            <br>
            <p style="color:rgb(105, 0, 0)">Please enter numbers.</p>
        </div>
    <br>
        <label>
            <textarea rows="5" cols="33" placeholder="Description" formControlName="description" required>
            </textarea>
        </label>    
    <br>
        <label>
            $ <input type="text" placeholder="Price" formControlName="price" pattern="[^[0-9]*$]" required>
          </label>  
            <p style="color:rgb(105, 0, 0)">Please enter numbers.</p>
        

    <br>
        <label>
            Item Status: 
            <select placeholder="Item Status" formControlName="itemStatus" required>
                <option>For Sale</option>
                <option>Sold</option>
            </select>
        </label>
    <br>
        <label>
            <input type="text" placeholder="Exchange Location" formControlName="exchangeLoc" required>
        </label>
    <br>
        <label>
            <input type="text" placeholder="Payment Option" formControlName="paymentOpt" required>
        </label>
    <br>
    <label for="listingphotos">Upload photo of item:</label> <br>
        <input type="file" id="imgInp" onchange="document.getElementById('images').src = window.URL.createObjectURL(this.files[0])" formGroupaName="listingForm" formControlName="listingPhotos" (change)="upload($event)" accept=".png,.jpg,.jpeg" required>
  
    <br>
        <button type="submit" (click)="onSubmit()">Post Listing</button>
    </form>

    <!-- Progress Bar for Picture Upload -->
    <!--
    <div *ngIf="progressValue | async as val">
        <progress type="warning"  [value]="val" style="height: 7mm; width: 50%" max="100" ></progress>
        <br />
        <span *ngIf="val<100" style="color:#b71c1c; font-size: 17px; font-weight: 410;">{{ val | number}}% </span><span *ngIf="val == 100" style="color:rgb(1, 153, 34);  font-size: 17px; font-weight: 410;"></span>
    </div>
    -->

    <!-- Please Wait... -->
    <div class="please-wait" role="alert">
        <h4 class="alert-heading"><strong>Please Wait...</strong></h4>
    </div>

    <!-- Confirmation Alert -->
    <div class="alertcss alert alert-success" role="alert">
        <h4 class="alert-heading">Listing has been successfully posted!</h4>
    </div>
    
</body>